<div class="slideshow-component">
  <button (click)="save()"
          class="simpleSaveButton"
          class="btn btn-primary"
          color="primary">Save</button>

  <div>
    <div [dragula]="'slideshow-bag'"
         [dragulaModel]="slides">
      <div class="row slide-row"
           *ngFor="let url of slides; let i = index">
        <div class="d-flex align-items-center justify-content-center">
          <div class="col-xs-2 sm-padding-top">
            <img class="thumbnail-image w-100"
                 [src]="slides[i]"
                 alt="thumbnail" />
          </div>
          <div class="col-xs-9 sm-padding-top">
            <input class="full-width"
                   type="text"
                   pInputText
                   [(ngModel)]="slides[i]" />
          </div>
          <div class="col-xs-1 sm-padding-top">
            <i class="fa fa-times fa-col removeUrl"
               (click)="removeSlider(i)"
               aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row padding-top">
      <div class="col-md-12">
        <button (click)="addSlider()"
                class="btn btn-secondary">
          Add Slide
        </button>
      </div>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/ng2/app/components/slideshow/slideshow.component.html